import React, { useState, useEffect } from "react";
import { Breadcrumb, BreadcrumbItem, Container } from "reactstrap";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import {
	storageItems,
	settingsItems,
	adminItems,
	utilItems,
	drillDownItems,
	deviceItems,
	virtualItems,
	virtualHostItems,
	vmItems,
	virtualClusterItems,
	virtualDatastoreItems,
	buItems,
	switchesItems,
	entHostItems,
	cloudItems,
	filesItems,
	backupItems,
	switchItems,
	hostItems,
	databaseItems,
	databaseServerItems,
	virtualVCenterItems,
} from "../utils/routes";
import { returnPathWithQuery, returnTitleWithQuery } from "../utils/Helpers";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function BreadCrumbs () {
	const history = useLocation();
	const [locationInfo, setLocationInfo] = useState([]);
	const [searchParams] = useSearchParams();
	
	const checkParam = (params, arr) => {
		// let param = arr.find(item => history.pathname.includes(item.path));
		let allParams = [];
		arr.forEach(item => history.pathname.includes(item.path) ? allParams.push(item) : null);
		allParams.forEach((param) => {
				params.push({
					...param,
					path: returnPathWithQuery(param.path, param.context, searchParams),
					title: returnTitleWithQuery(param.path, param.context, param.title, searchParams)
				});
		})
	}
	
	const checkReports = (pathNameSplit) => {
		let params = [];
		if (pathNameSplit.includes('reports')) {
			if (pathNameSplit.includes('storage')) {
				checkParam(params, storageItems);
				if (pathNameSplit.includes('device')) {
					params.push(storageItems[0]);
					checkParam(params, deviceItems);
				}
			}
			if (pathNameSplit.includes('virtual')) {
				checkParam(params, virtualItems);
				if (pathNameSplit.includes('host')) {
					params.push({
						...virtualItems[1],
						path: `${virtualItems[1].path}?unit=hosts`,
					});
					checkParam(params, virtualHostItems);
				} else if (pathNameSplit.includes('vm')) {
					params.push({
						...virtualItems[1],
						path: `${virtualItems[1].path}?unit=vms`,
					});
					checkParam(params, vmItems);
				} else if (pathNameSplit.includes('cluster')) {
					params.push({
						...virtualItems[1],
						path: `${virtualItems[1].path}?unit=clusters`,
					});
					checkParam(params, virtualClusterItems);
				} else if (pathNameSplit.includes('datastore')) {
					params.push({
						...virtualItems[1],
						path: `${virtualItems[1].path}?unit=datastores`,
					});
					checkParam(params, virtualDatastoreItems);
				} else if (pathNameSplit.includes('vcenter')) {
					params.push({
						...virtualItems[0],
						path: virtualItems[0].path,
					});
					checkParam(params, virtualVCenterItems);
				}
			}
			if (pathNameSplit.includes('hosts')) {
				checkParam(params, entHostItems);
				if (pathNameSplit.includes('host')) {
					params.push(entHostItems[0]);
					checkParam(params, hostItems);
				}
			}
			if (pathNameSplit.includes('file-analysis')) {
				checkParam(params, filesItems);
			}
			if (pathNameSplit.includes('business-unit')) {
				checkParam(params, buItems);
			}
			if (pathNameSplit.includes('san-switch')) {
				checkParam(params, switchesItems);
				if (pathNameSplit.includes('switch')) {
					params.push(switchesItems[0]);
					checkParam(params, switchItems);
				}
			}
			if (pathNameSplit.includes('cloud')) {
				checkParam(params, cloudItems);
			}
			if (pathNameSplit.includes('backup')) {
				checkParam(params, backupItems);
			}
			if (pathNameSplit.includes('database')) {
				checkParam(params, databaseItems);
				if (pathNameSplit.includes('server')) {
					params.push(databaseItems[1]);
					checkParam(params, databaseServerItems);
				}
			}
		}
		return params;
	}
	
	const checkSettings = (pathNameSplit) => {
		let params = [];
		if (pathNameSplit.includes('settings')) {
			let firstParam = utilItems.find(item => history.pathname.includes(item.path));
			if (firstParam) {
				params.push(firstParam);
			}
			let secondParam = settingsItems.find(item => history.pathname.includes(item.path));
			if (secondParam) {
				params.push(secondParam);
			}
		}
		return params;
	}
	
	const checkAdmin = (pathNameSplit) => {
		let params = [];
		if (pathNameSplit.includes('admin')) {
			let firstParam = utilItems.find(item => history.pathname.includes(item.path));
			if (firstParam) {
				params.push(firstParam);
			}
			
			let secondParam = adminItems.find(item => history.pathname.includes(item.path));
			if (secondParam) {
				params.push(secondParam);
			}
			
			let thirdParam = drillDownItems.find(item => history.pathname.includes(item.path));
			if (thirdParam) {
				params.push(thirdParam);
			}
		}
		return params;
	}
	
	const parsePathName = () => {
		let pathNameSplit = history.pathname.split("/");
		let reportParams = checkReports(pathNameSplit, searchParams);
		let settingsParams = checkSettings(pathNameSplit, searchParams);
		let adminParams = checkAdmin(pathNameSplit, searchParams);
		let params = [...new Set([...reportParams, ...settingsParams, ...adminParams])];
		setLocationInfo(params);
	}
	
	useEffect(() => {
		parsePathName();
	}, [history])
	
	return (
		<Container fluid className={"d-flex flex-row justify-content-between"}>
			<Breadcrumb>
				{locationInfo.map((crumb, index) => (
						<BreadcrumbItem active={index === locationInfo.length - 1} key={`breadcrumb-item-${index}`} style={{ textDecoration: 'none'}}>
							<Link to={crumb.path} style={{ textDecoration: 'none', color: index === locationInfo.length - 1 ? 'unset' : null}}>
								{decodeURIComponent(crumb.title)}
							</Link>
						</BreadcrumbItem>
				))}
			</Breadcrumb>
		</Container>
	)
}

export default withErrorBoundary(BreadCrumbs, GeneralErrorBoundary);